var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-create-ubl-archive-modal-wrapper",
    {
      on: {
        close: function ($event) {
          return _vm.close()
        },
      },
    },
    [
      _vm.downloadingFile
        ? _c("w-progress-linear", { staticClass: "full" })
        : _vm._e(),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("download-pdf-archive"),
                          expression: "$ct('download-pdf-archive')",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.download()
                        },
                      },
                    },
                    [
                      _c("w-fa", {
                        staticClass: "mr",
                        attrs: { icon: "download" },
                      }),
                      _vm._v(
                        _vm._s(
                          _vm.$ct("created-pdf-archive", {
                            fileName: _vm.createdArchive.FileName,
                          })
                        ) + " "
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-link",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.openSendMailDialog()
                        },
                      },
                    },
                    [
                      _c("w-fa", {
                        staticClass: "mr",
                        attrs: { icon: "envelope" },
                      }),
                      _vm._v(_vm._s(_vm.$ct("send-via-mail")) + " "),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c("w-input", {
                        ref: "input",
                        staticClass: "public-url-input",
                        attrs: { value: _vm.publicLink },
                        nativeOn: {
                          click: function ($event) {
                            return $event.target.select()
                          },
                        },
                      }),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("copy-public-url"),
                              expression: "$ct('copy-public-url')",
                            },
                          ],
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              return _vm.copyLink()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "copy" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.sendMailDialogOpened,
            callback: function ($$v) {
              _vm.sendMailDialogOpened = $$v
            },
            expression: "sendMailDialogOpened",
          },
        },
        [
          _vm.sendMailDialogOpened
            ? _c("app-send-message-dialog", {
                attrs: {
                  attachements: [_vm.downloadedFile],
                  content: "",
                  subject: _vm.$ct("mail-subject"),
                  title: _vm.$ct("send-pdf-archive"),
                },
                on: {
                  close: function ($event) {
                    _vm.sendMailDialogOpened = false
                  },
                  sent: function ($event) {
                    _vm.sendMailDialogOpened = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }